function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { useEffect, useState, useMemo } from 'react';
import { Table, Button, Card, Row, Col, Form } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { Loading } from '@rd-web-markets/shared/dist/util';
import claimEmployeesService from '../../services/claim/claim_employees.service';
import { handleError } from '@rd-web-markets/shared/dist/store/features/alertSlice';
import { useDispatch, useSelector } from 'react-redux';
import HelpControls from '@rd-web-markets/shared/dist/financialSection/HelpControls';
import { helpPages } from './Help';
import TeachingBubble from '@rd-web-markets/shared/dist/util/TeachingBubble';
import ClaimStateAlerts from '@rd-web-markets/shared/dist/claim/ClaimStateAlerts';
import { WagesRow, WagesHeading } from '.';
import { apiKey, getDefaultConfig } from '@rd-web-markets/shared/dist/util/tinyMceConfig';
import { Editor } from '@tinymce/tinymce-react';
import { ChangeHighlighter, FormattedNumberInput } from '@rd-web-markets/shared/dist/util';
import { useTranslation } from 'react-i18next';
export const WagesSection = _ref => {
  let {
    claim,
    debouncedSaveClaim,
    refreshClaim,
    setClaim,
    totalPayrollCostInvalid,
    project
  } = _ref;
  const user = useSelector(state => state.auth.user);
  const [claimEmployees, setClaimEmployees] = useState(null);
  const claimId = useMemo(() => claim === null || claim === void 0 ? void 0 : claim.id, [claim]);
  const dispatch = useDispatch();
  const {
    t
  } = useTranslation();
  const handleTinyMce = content => {
    setClaim(_objectSpread(_objectSpread({}, claim), {}, {
      employee_notes: content
    }));
  };
  useEffect(() => {
    async function getData() {
      try {
        if (claimId) {
          setClaimEmployees(await claimEmployeesService.all(claimId, project.id));
        }
      } catch (error) {
        dispatch(handleError(error));
      }
    }
    getData();
  }, [dispatch, claimId]);
  if (!claim || !claimEmployees) return /*#__PURE__*/React.createElement(Loading, null);
  const handleImport = async data => {
    for (const line of data.split('\n')) {
      if (line.length === 0) {
        continue;
      }
      const lineSplit = line.split('\t');
      const newEmployee = await claimEmployeesService.create({
        claim_id: claim.id,
        claim_project_report_id: project.id,
        name: lineSplit[0],
        role: lineSplit[1],
        base_salary: (lineSplit[2] || '').replace(',', ''),
        bonus: (lineSplit[3] || '').replace(',', ''),
        pension: (lineSplit[4] || '').replace(',', ''),
        reimbursed_expenses: (lineSplit[5] || '').replace(',', '')
      });
      setClaimEmployees([...claimEmployees, newEmployee]);
    }
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Card.Body, null, /*#__PURE__*/React.createElement(ClaimStateAlerts, {
    claim: claim
  }), /*#__PURE__*/React.createElement("div", {
    className: "text-end mb-2 me-2"
  }, /*#__PURE__*/React.createElement(TeachingBubble, {
    pages: helpPages,
    position: "left"
  })), /*#__PURE__*/React.createElement(HelpControls, {
    claim: claim,
    importProps: {
      placeholder: 'Employee Name       Employee Role       Salary       Bonus       Pension       Reimbursed Expenses',
      onSubmit: handleImport
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "pb-3"
  }), /*#__PURE__*/React.createElement(Card, null, /*#__PURE__*/React.createElement(Card.Header, {
    className: "bg-secondary"
  }, "Total Payroll Cost"), /*#__PURE__*/React.createElement(Card.Body, null, /*#__PURE__*/React.createElement(ChangeHighlighter, {
    as: FormattedNumberInput,
    thousandSeparator: " ",
    className: totalPayrollCostInvalid ? 'border-warning' : null,
    onChange: e => setClaim(_objectSpread(_objectSpread({}, claim), {}, {
      [e.target.name]: e.target.value
    })),
    onBlur: debouncedSaveClaim,
    disabled: claim.financials_locked,
    name: "total_payroll_cost",
    object: claim,
    size: "md",
    type: "text"
  }))), /*#__PURE__*/React.createElement(Table, {
    size: "sm",
    className: "table-scrollable-x"
  }, /*#__PURE__*/React.createElement("thead", {
    className: "text-center"
  }, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement(WagesHeading, null))), /*#__PURE__*/React.createElement("tbody", null, claimEmployees.map((_, index) => {
    return /*#__PURE__*/React.createElement(WagesRow, {
      key: index,
      index: index,
      claim: claim,
      claimEmployees: claimEmployees,
      setClaimEmployees: setClaimEmployees,
      refreshClaim: refreshClaim,
      claimEmployeesService: claimEmployeesService,
      ChangeHighlighter: ChangeHighlighter,
      FormattedNumberInput: FormattedNumberInput,
      handleError: handleError
    });
  }))), /*#__PURE__*/React.createElement(Card, null, /*#__PURE__*/React.createElement(Card.Header, {
    className: "bg-secondary"
  }, t('notes')), /*#__PURE__*/React.createElement(ChangeHighlighter, {
    as: Editor,
    apiKey: apiKey,
    onEditorChange: e => handleTinyMce(e),
    onKeyUp: () => debouncedSaveClaim(),
    onK: true,
    disabled: claim.financials_locked,
    object: claim,
    name: "employee_notes",
    init: getDefaultConfig()
  }))), /*#__PURE__*/React.createElement(Card.Footer, null, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    md: 6,
    className: "text-start"
  }, /*#__PURE__*/React.createElement(Button, {
    as: Link,
    variant: "light",
    to: "/".concat(user.account_type, "/claims/").concat(claim.id, "/financial_details/employees_activity")
  }, /*#__PURE__*/React.createElement("span", {
    className: "material-icons md-18"
  }, "chevron_left"), " Back")), /*#__PURE__*/React.createElement(Col, {
    md: 6,
    className: "text-end"
  }, /*#__PURE__*/React.createElement(Button, {
    as: Link,
    variant: "primary",
    to: "/".concat(user.account_type, "/claims/").concat(claim.id, "/financial_details/contractors")
  }, "Continue ", /*#__PURE__*/React.createElement("span", {
    className: "material-icons md-18"
  }, "chevron_right"))))));
};